<div class="slot-column">
    @if (!selectedState) {
    <div class="no-state-selected">
        <mat-icon>chevron_left</mat-icon>
        <p>Select a state to edit its layer layout.</p>
    </div>
    } @else {
    <div class="slot-editor">
        <div class="slot-editor-header">
            <div>
                <h3>{{ selectedState }}</h3>
                <p class="slot-editor-hint">Add layers with absolute positioning. Lower z-index renders first.</p>
            </div>
            <span class="layer-count-chip">{{ editingLayers().length }} layer{{ editingLayers().length === 1 ? '' : 's'
                }}</span>
        </div>
        <!-- transientDurationSeconds section -->
        <div class="transient-duration-section">
            <mat-form-field appearance="fill" class="transient-duration-field">
                <mat-label>Transient Duration (seconds)</mat-label>
                <input matInput type="number" min="0" [(ngModel)]="editingTransientDuration" />
                <mat-hint>Optional duration for transient states. Leave blank for default.</mat-hint>
            </mat-form-field>
        </div>
        <div class="slots-list">
            @for (layer of editingLayers(); track $index) {
            <app-layer-edit-item [layer]="layer" [index]="$index" [layerTypes]="layerTypes"
                [selectedState]="selectedState" [pendingImageFile]="getPendingFile($index)"
                (layerChange)="updateLayer($index, $event)" (remove)="removeLayer($index)"
                (imageFileSelected)="setPendingImage($index, $event)" />
            } @empty {
            <p class="no-slots-hint">No layers yet. Add layers to build this state's layout.</p>
            }
        </div>

        <div class="slot-editor-footer">
            <button mat-stroked-button (click)="addLayer()">
                <mat-icon>add</mat-icon> Add Layer
            </button>
            <button mat-raised-button color="primary" [disabled]="!canSave || saving" [matTooltip]="saveTooltip"
                (click)="submit()">
                <mat-icon>save</mat-icon> Save Layout
            </button>

        </div>
        <!-- Error message container -->
        @if (errorMessage) {
        <div class="error-message">
            <mat-icon>error</mat-icon>
            <span>{{ errorMessage }}</span>
        </div>
        }
    </div>
    }
</div>